import { h } from "preact";

export const TAB_ALL = "all";

/**
 * Material-group filter. A radio group under the hood, so keyboard and
 * screen-reader behaviour come free — same trade as segmented-toggle.
 */
export default function SwatchDetailsTabs({ name, groups, value, onChange }) {
  const strings = window.localeStrings.swatch_details;

  const tabs = [
    { value: TAB_ALL, label: strings.tab_all },
    ...groups.map((group) => ({ value: group, label: group })),
  ];

  return (
    <fieldset className="swatch-details-drawer__tabs">
      <legend className="visually-hidden">
        {strings.tabs_accessible_label}
      </legend>
      {tabs.map((tab) => (
        <label key={tab.value} className="swatch-details-drawer__tab">
          <input
            className="swatch-details-drawer__tab-input"
            type="radio"
            name={name}
            value={tab.value}
            checked={tab.value === value}
            onChange={(e) => onChange(e.target.value)}
          />
          <span className="swatch-details-drawer__tab-label">{tab.label}</span>
        </label>
      ))}
    </fieldset>
  );
}
